module.exports = "/images/bs.svg?792dad43f114427914ffec364e9d1f40";